import DropDownList from '../../Dropdown/DropDownList';
import GroupSVG from '../../icons/group';
import UserSVG from '../../icons/user';
import UserAddSVG from '../../icons/userAdd';
import UserInfoSVG from '../../icons/userInfo';
import DocSVG from '../../icons/doc';
import PaySVG from '../../icons/pay';
import GroupsTabSVG from '../../icons/groupstab';
import ArticleSVG from '../../icons/article';
import ExchangeSVG from '../../icons/exchange';
import CashCutSVG from '../../icons/cashCut';
import ReceiptSVG from '../../icons/receipt'
import PaymentPlanSVG from '../../icons/payplan';

const RecepMenu = ({ onMenuItemClick, priv }) => {  // Recibe la función como prop

    const MenuData = [
        {
            name: "Alumnos",
            icon: UserSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Registrar alumno",
                    icon: UserAddSVG,
                    link: "#",
                    status: "active",
                },
                {
                    name: "Info alumno",
                    icon: UserInfoSVG,
                    link: "#",
                    status: "active",
                },
            ],
        },
        {
            name: "Grupos",
            icon: GroupSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Tabla de grupos",
                    icon: GroupsTabSVG,
                    link: "#",
                    status: "disabled",
                },
                {
                    name: "Listado de grupos",
                    icon: GroupSVG,
                    link: "#",
                    status: "active",
                },
                {
                    name: "Seguimiento de maestros",
                    icon: GroupSVG,
                    link: "#",
                    status:"active",
                },
            ],
        },
        {
            name: "Pagos",
            icon: PaySVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Recibo de pago",
                    icon: ReceiptSVG,
                    link: "#",
                    status: "active",
                },
                {
                    name: "Lista de adeudos",
                    icon: PaymentPlanSVG,
                    link: "#",
                    status:"active",
                },
                {
                    name: "Tipo de cambio",
                    icon: ExchangeSVG,
                    link: "#",
                    status: "active",
                },
                {
                    name: "Corte de caja",
                    icon: CashCutSVG,
                    link: "#",
                    status: "active",
                },
            ],
        },
        {
            name: "Formatos",
            icon: DocSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Diplomas y Constancias",
                    icon: ArticleSVG,
                    link: "#",
                    status: "active",
                },
            ],
        },

    ];

    return (
        <DropDownList
            Data={MenuData}
            iconColor='red'
            onMenuItemClick={onMenuItemClick} // Pasa la función a DropDownList
        />
    );
};

export default RecepMenu;
